if (!customElements.get('search-suggestions')) {
  const SearchSuggestions = class extends HTMLElement {
    connectedCallback() {
      this.searchTimeoutID = -1;
      this.searchInput = this.closest('form').querySelector('input[name="q"]');
      this.searchInput.addEventListener('keyup', this.handleInputChange.bind(this));
      this.searchInput.addEventListener('input', this.handleInputChange.bind(this));
      this.searchInput.addEventListener('change', this.handleInputChange.bind(this));
    }

    handleInputChange() {
      const valueToSearch = this.searchInput.value;

      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        clearTimeout(this.searchTimeoutID);

        this.searchTimeoutID = setTimeout(() => {
          this.fetchSuggestions(valueToSearch);
        }, 500);
      } else if (!valueToSearch.length) {
        clearTimeout(this.searchTimeoutID);
        this.innerHTML = '';
      }

      this.oldSearchValue = valueToSearch;
    }

    fetchSuggestions(terms) {
      const indexNode = document.querySelector('[data-model-index]');
      const indexUrl = indexNode ? indexNode.getAttribute('data-model-index') : '';
      if (!(window.AwModelSearch && window.AwModelSearch.loadIndex && indexUrl)) {
        this.innerHTML = '';
        return;
      }

      window.AwModelSearch.loadIndex(indexUrl).then((index) => {
        if (this.searchInput.value !== terms) return;
        const hits = window.AwModelSearch.searchIndex(index, terms, 4);
        if (!hits.length) {
          this.innerHTML = '';
          return;
        }
        const wrapper = document.createElement('div');
        wrapper.className = 'search-suggestions';
        const heading = document.createElement('span');
        heading.className = 'search-suggestions__heading';
        heading.setAttribute('role', 'heading');
        heading.setAttribute('aria-level', '2');
        heading.textContent = 'Suggestions:';
        const list = document.createElement('ul');
        list.className = 'search-suggestions__results-list';
        hits.forEach((item) => {
          const li = document.createElement('li');
          li.className = 'search-suggestions__list-item';
          const anchor = document.createElement('a');
          anchor.className = 'search-suggestions__item';
          anchor.href = '/collections/' + item.h;
          anchor.textContent = item.t;
          li.appendChild(anchor);
          list.appendChild(li);
        });
        wrapper.appendChild(heading);
        wrapper.appendChild(list);
        this.innerHTML = '';
        this.appendChild(wrapper);
      }).catch(() => {
        if (this.searchInput.value === terms) this.innerHTML = '';
      });
    }
  };

  window.customElements.define('search-suggestions', SearchSuggestions);
}
